import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Avatar from 'material-ui/Avatar';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import colors from '../assets/colors.js';
import iconLinkedIn from '../assets/iconLinkedIn.png';
import iconResume from '../assets/iconResume.png';

class ForeignFunding extends React.Component {

  render() {
    return (
  		<p>
        The great majority of the foundation's philanthropic efforts are in making Program Related Investments,
        usually loans, to credit worthy US domestic 501(c)3s. The foundation does not extend credit to foreign based
        entities.
      </p>
    );
  }
}


export default ForeignFunding;


// WEBPACK FOOTER //
// ./src/components/ForeignFunding.js